// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2nmQq","inputWrap":"styles_inputWrap__1vNbd","input":"styles_input__19duF"};